import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
//#region src/properties/usePublicPropertyQuery.ts
var r = (r, i) => t({
	queryKey: e.publicProperty(r, i),
	queryFn: () => n.getPublicProperty(r, i),
	enabled: !!r,
	placeholderData: (e) => e
});
//#endregion
export { r as usePublicPropertyQuery };
